module.exports = __webpack_public_path__ + "img/lille-logo-icon.f0328c18.png";